export default {
  release: '19.1',
  date: 'June 2026',
  releasePostUrl: 'https://docs.gitlab.com/releases/19/gitlab-19-1-released/',
  contributors: [
    {
      name: 'Pishel',
      gitlabUsername: 'pishel65',
      linkedIn: 'https://www.linkedin.com/in/itay-fishel-84a97222a',
    },
  ],
  writeUp: `We are excited to recognize Pishel, a Level 3 contributor whose recent work has made a strong impact across GitLab Runner and related documentation.

Nominated by [Axel von Bertoldi](https://gitlab.com/avonbertoldi), Senior Backend Engineer at GitLab, Pishel stood out for sustained contributions in an area that has especially benefited from thoughtful community support, including Windows Runner behavior, CI/CD networking improvements, and clear documentation updates that help users put those features into practice.

Recent highlights include [fixing random shell selection in the Windows shell executor](https://gitlab.com/gitlab-org/gitlab-runner/-/merge_requests/6644) and [adding the CI_BUILD_NETWORK_NAME variable for FF_NETWORK_PER_BUILD](https://gitlab.com/gitlab-org/gitlab-runner/-/merge_requests/6632), alongside a steady stream of follow-up documentation and issue work.

What makes Pishel's contributions stand out is the combination of technical depth, persistence, and collaboration. He consistently identifies real user pain points, follows through with implementation, and helps move related work forward for the wider community.

Thank you for your continued contributions to GitLab and the wider community!`,
};
